define('datakit/mixin/relationships.mixin',['require','exports','module','underscore','backbone','marionette','backbone.radio','bluebird','../lib/resource.relationship','../lib/belongs.to.relationship.type','../util/enable.relationship.lazy.loading'],function(require, exports, module) {
  var _                             = require('underscore');
  var Backbone                      = require('backbone');
  var Mn                            = require('marionette');
  var Radio                         = require('backbone.radio');
  var Promise                       = require('bluebird');
  var ResourceRelationship          = require('../lib/resource.relationship');
  var BelongsToRelationshipType     = require('../lib/belongs.to.relationship.type');
  var enableRelationshipLazyLoading = require('../util/enable.relationship.lazy.loading');


  var RELATIONSHIPS_NAME = 'relationships';

  var RelationshipsMixin = {

    relationshipClass: ResourceRelationship,

    defaultRelationshipTypeClass: BelongsToRelationshipType,

    relationshipTypes: ResourceRelationship.DEFAULT_RELATIONSHIP_TYPES,

    initializeMixin: function(attrs, options) {
      options || (options = {});

      var relationships = _.result(this, RELATIONSHIPS_NAME);
      var relationshipOptions = _.result(options, RELATIONSHIPS_NAME) || {};

      this.relationships = {};

      this.on('sync', function() {
        enableRelationshipLazyLoading(this);
      });

      this.disableRelationships = !!_.result(this, 'disableRelationships')
          || !!_.result(options, 'disableRelationships');
      
      _.each(_.result(this, 'upstreamCascadedRelationships'), function(relationshipName) {
        this.once('create:relationship:' + relationshipName, function() {
          this.bindFetchToRelationshipUpdate(this.getRelationship(relationshipName));
        });
      }, this);

      _.each(relationships, function(relationship, name) {
        this.addRelationship(name, _.extend({}, relationship, relationshipOptions[name]));
      }, this);

      this.on('sync', function(self, response, options) {
        var syncMethod =  _.result(options, 'syncMethod');
        if (syncMethod == 'create' || syncMethod == 'update') {
          ResourceRelationship.handleDownstreamCascadedRelationships(this,
            _.result(this, 'downstreamCascadedRelationships'));
        }
        else if (syncMethod == 'destroy') {
          this.clearRelationships();
        }
      });

      // register the getter when the attr contains the relationship name prefix
      this.registerGetter(this.isRelationshipAttribute, this.getRelationshipData)
      // relationships should be readonly so the setter should do nothing
      this.registerSetter(this.isRelationshipAttribute, _.noop);
    },

    isRelationshipAttribute: function(attr) {
      var parts = String(attr).split('.');
      if (this.hasRelationship(_.first(parts))) {
        return true;
      } else if (this.startsWithRelationshipsPrefix(attr)) {
        return true;
      }
      return false;
    },

    eachRelationshipResource: function(fn, context) {
      if (!_.isFunction(fn)) { return this; }

      _.each(this.relationships, function(relationship, name) {
        fn.call(context || this, relationship.resource, name)
      }, this);

      return this;
    },

    bindFetchToRelationshipUpdate: function(relationship) {
      this.listenTo(relationship.resource, 'sync', function(resource, response, options) {
        var syncMethod =  _.result(options, 'syncMethod');
        if (syncMethod == 'create' || syncMethod == 'update' || syncMethod == 'destroy') {
          this.fetch();
        }
      });
    },

    startsWithRelationshipsPrefix: function(name) {
      if (this.disableRelationships === true) {
        return false;
      }
      else {
        return (String(name).indexOf(RELATIONSHIPS_NAME + '.') === 0)
      }
    },

    addRelationship: function(name, relationship) {
      // store the relationship
      this.relationships[name] = _.extend({}, relationship, {
        name: name,
        foreignModel: this
      });

      var fetchMode = _.result(this.relationships[name], 'fetchMode');

      if (fetchMode === ResourceRelationship.EAGER_FETCH) {
        this.getRelationship(name);
      }

      return this;
    },

    enableRelationshipLazyLoading: function() {
      this.lazyLoadingEnabled = true;
      this.processRelationshipFetchQueue();
      return this;
    },

    disableRelationshipLazyLoading: function() {
      this.lazyLoadingEnabled = false;
      return this;
    },

    getRelationshipResource: function(relationshipName) {
      if (this.hasRelationship(relationshipName)) {
        return this.getRelationship(relationshipName).resource;
      }
      return;
    },

    getRelationshipData: function(attr) {
      if (!_.isString(attr)) { return; }


      var originalAttrRequest = attr;

      if (this.startsWithRelationshipsPrefix(attr)) {
        // remove relationship prefix from the attribute name
        attr = attr.slice(RELATIONSHIPS_NAME.length+1);
      }

      var sections = attr.split('.');
      var relationshipName = sections[0];
      var dataPathArray = _.rest(sections);
      var dataPath = dataPathArray.join('.');

      if (!this.hasRelationship(relationshipName)) { return; }

      var relationship = this.getRelationship(relationshipName);
      if (!relationship) {
        return;
      }
      var resource = relationship.resource;
      relationship.addBoundAttributePath(originalAttrRequest, dataPath);
      if (!relationship.isFetched() && Mn.getOption(relationship, 'fetchMode') == ResourceRelationship.LAZY_LOAD) {
          this.fetchRelationship(relationship);
      }
      if (!dataPath) {
        // if no specific data path is provided, then return the resource
        return resource;
      }
      if (resource instanceof Backbone.Model) {
        return resource.get(dataPath);
      }
    },

    fetchRelationship: function(relationship) {
      this.queueRelationshipFetch(relationship);
      return this;
    },

    queueRelationshipFetch: function(relationship) {
      var self = this;
      this._relationshipFetchQueue || (this._relationshipFetchQueue = []);

      if (_.isString(relationship)) {
        relationship = this.getRelationship(relationship);
      }
      if (!relationship) { return; }

      if (!_.contains(this._relationshipFetchQueue, relationship)) {
        this._relationshipFetchQueue.push(relationship);
      }
      _.defer(function() {
        self.processRelationshipFetchQueue();
      });
    },

    processRelationshipFetchQueue: function() {
      if (!this.lazyLoadingEnabled || this.disableRelationships) {
        // do not make requests if lazy loading is disabled
        // or relationships are disabled
        return this;
      }
      var relationshipFetchQueue = this._relationshipFetchQueue;
      this._relationshipFetchQueue = [];
      _.each(relationshipFetchQueue, function(relationship) {
        relationship.fetchResource();
      }, this);
      return this;
    },

    getRelationship: function(name) {
      var relationship = this.relationships[name];
      if (this.disableRelationships === true) {
        return;
      }
      if (!this.hasCreatedRelationship(name)) {
        try {
          relationship = this.relationships[name] = new this.relationshipClass(relationship);
        } catch (e) {
          Promise.reject(e);
          return null;
        }
        Mn.triggerMethodOn(this, 'create:relationship', this, {
          name: name,
          relationship: relationship
        });
        Mn.triggerMethodOn(this, 'create:relationship:' + name, this, {
          name: name,
          relationship: relationship
        });
      }
      return relationship;
    },

    hasCreatedRelationship: function(name) {
      return (this.relationships[name] instanceof Mn.Object);
    },

    hasRelationship: function(name) {
      return !!this.relationships[name]
    },

    clearRelationships: function() {
      _.each(this.relationships, function(relationship, name) {
        this.clearRelationship(name);
      }, this);
      return this;
    },

    clearRelationship: function(name) {
      if (this.hasCreatedRelationship(name)) {
        this.getRelationship(name).clearResource();
      }
      return this;
    }

  };

  module.exports = RelationshipsMixin;
});
